import styled from 'styled-components';

export const ResultFilters = styled.div`
  display: flex;
  flex-direction: column;
`;
